export const VARIANT = {
  DASHBOARD: 'DASHBOARD',
  SALES_INFO: 'SALES_INFO'
};

export const DEFAULT_VARIANT = VARIANT.DASHBOARD;
